import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/auth";
import "./register.css";

import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai"

const PasswordFelid = (props) => {

    const { placeholder } = props

    const [inputType, setInputType] = useState("password")

    const handleInputTypeChange = () => {
        setInputType(prev => prev === "password" ? "text" : "password")
    }

    return (
        <span className="user__form_input-grp-password d-flex">
            <input type={inputType} placeholder={placeholder ? placeholder : "Password"} />
            <button className="null-btn" type="button" onClick={handleInputTypeChange}>
                {
                    inputType === "text" ? <AiOutlineEye color="black" fontSize={24} /> : <AiOutlineEyeInvisible color="black" fontSize={24} />
                }

            </button>
        </span>
    )
}

export const Register = () => {
    const { setLoggedIn } = useAuth();
    const navigate = useNavigate();

    const handleUserRegister = (e) => {
        e.preventDefault()
        setLoggedIn(true)
        navigate("/")
    }

    return (
        <main className="lyt__login">
            <h1 className="page__title ">SignUp</h1>
            <form className="user__form d-flex--c">
                <div className="d-flex flex-justify-between gap-10">

                    <div className="user__form_input-grp d-flex--c w-100">
                        <label>*First name:</label>
                        <input type="text" placeholder="First name" />
                    </div>
                    <div className="user__form_input-grp d-flex--c w-100">
                        <label>*Last name:</label>
                        <input type="text" placeholder="Last name" />
                    </div>
                </div>
                <div className="user__form_input-grp d-flex--c">
                    <label>*Enter your username:</label>
                    <input type="text" placeholder="Username" />
                </div>
                <div className="user__form_input-grp d-flex--c">
                    <label>*Email Id:</label>
                    <input type="text" placeholder="Email Id" />
                </div>

                <div className="d-flex flex-justify-between gap-10">
                    <div className="user__form_input-grp d-flex--c w-100">
                        <label>City:</label>
                        <input type="text" placeholder="City" />
                    </div>
                    <div className="user__form_input-grp d-flex--c w-100">
                        <label>Country:</label>
                        <input type="text" placeholder="Country" />
                    </div>
                </div>

                <div className="user__form_input-grp d-flex--c">
                    <label>*Enter your password:</label>
                    <PasswordFelid />
                </div>
                <div className="user__form_input-grp d-flex--c">
                    <label>*Confirm password:</label>
                    <PasswordFelid placeholder="Confirm password" />
                </div>
                <label className="c-white">Security Question</label>
                <div className="user__form_input-grp d-flex--c">
                    <select >
                        <option selected disabled value={null}>Select an Question</option>
                        <option value={"pet_name"}>What is your pet name?</option>
                        <option value={"frnd_name"}>What is your childhood friend name?</option>
                    </select>
                    <input type="text" placeholder="Your answer" />
                </div>
                <div className="user__form_input-grp d-flex">
                    <input type={"checkbox"} />
                    <label>I agree to all Terms & Conditions.</label>
                </div>
                <button onClick={handleUserRegister} className="user__form__button">Register</button>

            </form>
        </main>
    );
};
